import React from 'react';

interface SectionHeaderProps {
  icon: React.ElementType;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function SectionHeader({
  icon: Icon,
  title,
  description,
  action
}: SectionHeaderProps) {
  return (
    // flex-wrap: reicht der Platz nicht, rutscht die Aktion unter den Titel,
    // statt aus der Card zu laufen. Solange alles passt, aendert sich nichts.
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
          <Icon className="w-5 h-5 text-slate-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
          {description && <p className="text-sm text-slate-500">{description}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}
